import { ORGANIZATIONS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function updateOrganizationCustomCredential(data) {
	const url = `/${ORGANIZATIONS_PREFIX}/updateCustomCredentials`;
	return postApi(url, data);
}
